import { reactive } from 'vue'

export type ConnectionState = 'online' | 'reconnecting' | 'offline'

export const network = reactive<{
  state: ConnectionState
  lastOnlineAt: number | null
}>({
  state: navigator.onLine ? 'online' : 'offline',
  lastOnlineAt: navigator.onLine ? Date.now() : null,
})

let reconnectTimer: number | undefined

export function initializeNetworkMonitoring(): void {
  window.addEventListener('offline', () => {
    network.state = 'offline'
  })
  window.addEventListener('online', () => {
    network.state = 'reconnecting'
    if (reconnectTimer !== undefined) window.clearTimeout(reconnectTimer)
    reconnectTimer = window.setTimeout(() => {
      network.state = navigator.onLine ? 'online' : 'offline'
      if (network.state === 'online') network.lastOnlineAt = Date.now()
    }, 800)
  })
}
